import { ampliarTablaXML } from './procesaCicloFor-ampliarTablaXML'
import { reemplazaForiConCantidad } from './procesaCicloFor-ampliarTablaXML'
import { cantidadRegistros } from './procesaCicloFor-ampliarTablaXML'
import { expandFori } from './procesaCicloFor-expandFori'
/**
 * Simplifica los for y fori en el XML:
 * - Añade el prefijo acumulado a cada fori según los for anidados
 * - Elimina los tokens for y forend
 * - Deja los fori con [] para el siguiente paso
 * param {string} xml
 * returns {string}
 */
export function procesaCicloFor(xml, datos) {
  //console.log('Procesando ciclo for en XML...');
  let resultado = ''
  let i = 0
  const len = xml.length
  let stack = [] // Acumula los campos de los for anidados

  while (i < len) {
    // Buscar el siguiente token for, forend o fori
    const forMatch = xml.slice(i).match(/\$\{for:([^\}]+)\}/)
    const forendMatch = xml.slice(i).match(/\$\{forend:([^\}]+)\}/)
    const foriMatch = xml.slice(i).match(/\$\{fori:([^\}]+)\}/)

    // Determinar cuál aparece primero
    let next = null
    let tipo = ''
    if (
      forMatch &&
      (!forendMatch || forMatch.index < forendMatch.index) &&
      (!foriMatch || forMatch.index < foriMatch.index)
    ) {
      next = forMatch
      tipo = 'for'
    } else if (forendMatch && (!foriMatch || forendMatch.index < foriMatch.index)) {
      next = forendMatch
      tipo = 'forend'
    } else if (foriMatch) {
      next = foriMatch
      tipo = 'fori'
    }

    if (!next) {
      // No hay más tokens, añadir el resto
      resultado += xml.slice(i)
      break
    }

    // Añadir texto antes del token
    resultado += xml.slice(i, i + next.index)

    if (tipo === 'for') {
      // Añadir campo al stack
      stack.push(next[1])
      i += next.index + next[0].length
    } else if (tipo === 'forend') {
      // Quitar campo del stack
      stack.pop()
      i += next.index + next[0].length
    } else if (tipo === 'fori') {
      // Construir prefijo acumulado
      let prefijo = stack.map((c) => `${c}[]`).join('.')
      if (prefijo) prefijo += '.'
      resultado += `\${fori:${prefijo}${next[1]}}`
      i += next.index + next[0].length
    }
  }
  //console.log('Resultado XML inicial:', resultado);
  //resultado = ampliarTablaXML(resultado, datos)
  resultado = expandFori(resultado, datos)
  return resultado
}